// Module 11: behind the Caddy reverse proxy the API lives on the SAME origin,
// so we want API_URL = "" (calls become relative: fetch('/api/...')).
// Use ?? not || : || would treat the intentional empty string "" as "missing"
// and wrongly fall back to localhost. ?? only falls back when it's truly unset
// (e.g. running `npm start` with no env var during plain local dev).
export const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:3000';

// Module 14 demo (frontend dev): a single source of truth for the app name.
export const APP_NAME = 'HAND Network';
